export default __webpack_public_path__ + "static/media/pt.ba9c7874.svg";